import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DataService } from "../data.service";
import { INavbarModule } from "../sidenavbar.module";
import { LocalStorageService } from '../_services/local-storage.service';
import { AiSourcingHandlerService } from '../_services/ai-sourcing-handler.service';
declare const clevertap;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {

  isActive : boolean = false;
  isSearchActive: boolean = false;
  isSearchToolboxV2Active: boolean = false;
  isCompanyPagesActive: boolean = false;
  isPersonSearchActive: boolean = false;
  isAiSourcingActive: boolean = false;
  isNLSearchActive:boolean = false;
  atsResumeScreeningActive: boolean = false;
  isTalentpoolInsightPagesActive:boolean = false;
  isProjectsActive: boolean = false;
  get navModules(): INavbarModule[] {
    return this.dataService.getNavModules || [];
  }

  constructor(public router: Router,
    private dataService: DataService,
    private localStorageService: LocalStorageService,
    private aiSourcingHandlerService: AiSourcingHandlerService
  ) {}

  ngOnInit() {
    if (this.router.url.includes('talent/talentpool')){
      this.isActive = true
    }
    else if (this.router.url.includes('smartsearch')){
      this.isSearchActive = true
    }
    else if (this.router.url.includes('searchtoolbox-v2')){
      this.isSearchToolboxV2Active = true
    }
    else if(this.router.url.includes('company-directory')){
      this.isCompanyPagesActive = true;
    }
    else if(this.router.url.includes('person-search')){
      this.isPersonSearchActive = true;
    }
    else if(this.router.url.includes('ai-sourcing')){
      this.isAiSourcingActive = true;
    }
    else if(this.router.url.includes('nl-search')){
      this.isNLSearchActive = true;
    }
    else if(this.router.url.includes('resume-screen')){
      this.atsResumeScreeningActive = true;
    }
     else if(this.router.url.includes('talentpool-insights')){
      this.isTalentpoolInsightPagesActive = true;
    } else if (this.router.url.includes('projects')){
      this.isProjectsActive = true;
    }

  }

  Route2ToolBox(toolboxVersion: string){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      if (toolboxVersion === 'version1.0') {
        this.router.navigate(['/smartsearch']);
      } else if (toolboxVersion === 'version2.0') {
        this.router.navigate(['/searchtoolbox-v2']);
      }
    });
  }

  getCleverTapEvents(type) {
    if (type == 'Ai Sourcing') {
      this.aiSourcingHandlerService.setDisplayPageEvent('ai-sourcing');
    };
    const navbarParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "type": type
    }
    clevertap.event.push('Navbar Click', navbarParams);
  }

  goToDefault() {
    this.router.navigate(['/search']);
  }
}
